require('dotenv').config()
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import { errorMessage, successMessage } from '@/helper'
import currencyFilter from '@/filters/currency.filter'
import thousandDividerFilter from '@/filters/thousand-divider.filter'
import VueLazyload from 'vue-lazyload'

Vue.filter('currencyFilter', currencyFilter)
Vue.filter('thousandDividerFilter', thousandDividerFilter)

Vue.use(VueLazyload)
//  vuelidate
Vue.use(Vuelidate)

Vue.prototype.$errorMessage = errorMessage
Vue.prototype.$successMessage = successMessage

//smooth scroll
import VueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(VueSmoothScroll, {
  duration: 1000,
})

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//styles
require('./sass/main.scss')

// Import ElementUI
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import VueSplide from '@splidejs/vue-splide'

Vue.use(ElementUI, { locale })
Vue.use(VueSplide)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
